module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_List_of_Plates"
    }
  }, [_vm._v("List of Plates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("1.")]), _vm._v(" The State of the Nation – Sparta in 478 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BC")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("2.")]), _vm._v(" The First Cracks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("3.")]), _vm._v(" The Misadventures of Pausanias")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("4.")]), _vm._v(" The Slide into War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("5.")]), _vm._v(" The Archidamian War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("6.")]), _vm._v(" Sphacteria and the Peace of Nicias")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("7.")]), _vm._v(" A Successful War and a Failed Peace")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("8.")]), _vm._v(" The Lame King")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("9.")]), _vm._v(" The Disaster at Leuctra")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("10.")]), _vm._v(" The Rise of Macedon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("11.")]), _vm._v(" The Failed Reformers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_hang"
  }, [_vm._v("12.")]), _vm._v(" Nabis and the End of Sparta")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0